import React from "react";
import { ExternalLink } from "react-feather";
import { useKgCanvasNavigation } from "../../kg/canvas/KgCanvasNavigationContext";
import {
  Arrow,
  ExternalLinkButton,
  FocusLinkButton,
  PathLabel,
  Row,
  TableName,
  TargetName,
} from "../KgInspectorPathLinkRow/KgInspectorPathLinkRow.styles";
import type { KgInspectorPathNavLinkRowProps } from "./KgInspectorPathNavLinkRow.types";

export const KgInspectorPathNavLinkRow: React.FC<
  KgInspectorPathNavLinkRowProps
> = ({ link, pathSuffix }) => {
  const { focusNode } = useKgCanvasNavigation();

  return (
    <Row>
      <PathLabel>
        {link.canvasNodeId ? (
          <FocusLinkButton
            type="button"
            onClick={() => focusNode(link.canvasNodeId!)}
            aria-label={`Show ${link.label} on graph`}
          >
            <TableName>{link.label}</TableName>
          </FocusLinkButton>
        ) : (
          <TableName>{link.label}</TableName>
        )}
        <Arrow aria-hidden>→</Arrow>
        <TargetName>{pathSuffix}</TargetName>
      </PathLabel>
      {link.externalUrl && (
        <ExternalLinkButton
          href={link.externalUrl}
          target="_blank"
          rel="noreferrer"
          aria-label={`Open ${link.label} → ${pathSuffix} in a new tab`}
        >
          <ExternalLink size={14} />
        </ExternalLinkButton>
      )}
    </Row>
  );
};

export default KgInspectorPathNavLinkRow;
